import React, { useState } from 'react';
import './IRAValidation.css';

const IRAValidation = ({ onValidationSuccess, onBack }) => {
  const [iraNumber, setIraNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [validatedData, setValidatedData] = useState(null);

  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    setIraNumber(value);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!iraNumber.trim()) {
      setError('Please enter your IRA number');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // Get API base URL from config
      const getApiBaseUrl = () => {
        if (process.env.REACT_APP_API_URL) {
          return process.env.REACT_APP_API_URL;
        }
        if (typeof window !== 'undefined' && window.location) {
          const hostname = window.location.hostname;
          if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'http://10.25.30.30:8445';
          }
          return `http://${hostname}:8445`;
        }
        return 'http://10.25.30.30:8445';
      };

      const response = await fetch(`${getApiBaseUrl()}/api/validate-ira`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ iraNumber: iraNumber.trim() }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to validate IRA number');
      }

      if (data.success) {
        setValidatedData(data.data);
        // Store validated IRA data in localStorage for later use
        localStorage.setItem('bimabot_validated_ira', JSON.stringify(data.data));
        // Call success callback after a brief delay to show success message
        setTimeout(() => {
          onValidationSuccess(data.data);
        }, 1500);
      } else {
        throw new Error(data.error || 'Validation failed');
      }
    } catch (err) {
      console.error('IRA validation error:', err);
      setError(err.message || 'Failed to validate IRA number. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ira-validation">
      <div className="ira-validation-container">
        <div className="ira-validation-header">
          <div className="ira-validation-icon">🛡️</div>
          <h1>Agent Verification</h1>
          <p>Enter your IRA number to continue</p>
        </div>

        {validatedData ? (
          <div className="ira-validation-success">
            <div className="success-icon">✅</div>
            <h2>Verification Successful!</h2>
            <div className="validated-info">
              <p><strong>Agency Name:</strong> {validatedData.agencyName}</p>
              <p><strong>IRA Number:</strong> {validatedData.iraNumber}</p>
              {validatedData.dateLicensed && (
                <p><strong>Date Licensed:</strong> {validatedData.dateLicensed}</p>
              )}
            </div>
            <p className="success-message">Redirecting to product selection...</p>
          </div>
        ) : (
          <form className="ira-validation-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="iraNumber">IRA Number</label>
              <input
                type="text"
                id="iraNumber"
                name="iraNumber"
                value={iraNumber}
                onChange={handleInputChange}
                placeholder="e.g., IRA/05/36231/2025"
                required
                disabled={isLoading}
                autoFocus
                className={error ? 'error' : ''}
              />
              {error && <div className="error-message">{error}</div>}
              <small className="form-hint">
                Enter your Insurance Regulatory Authority (IRA) license number
              </small>
            </div>

            <div className="form-actions">
              <button
                type="submit"
                className="btn-primary"
                disabled={isLoading || !iraNumber.trim()}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span>
                    Validating...
                  </>
                ) : (
                  'Validate & Continue'
                )}
              </button>
            </div>
          </form>
        )}

        {onBack && (
          <button className="btn-back" onClick={onBack} disabled={isLoading}>
            ← Back
          </button>
        )}
      </div>
    </div>
  );
};

export default IRAValidation;

